module.exports = __webpack_public_path__ + "static/slider_5-b3bf51f0781da20530e194ec4850b46f.jpg";